import React from 'react'

import { Link } from 'react-router-dom';

export default function RecipesBig(props) {

  const cards = props.data;
  return (
    <>
     <div>
      {cards.map((card, index) => (
        <div key={index}>
          <Link to={`/recipe/${card.id}`}>
          <div className='cardImage'>
            <img src={card.image} alt={`Card Image ${index + 1}`} />
          </div>
          </Link>
          <div className='content container-fluid'>
            <Link to={`/recipe/${card.id}`} style={{textDecoration: 'none'}}>
            <div className='type'>{card.type}</div>
            </Link>
            <Link to={`/recipe/${card.id}`} className='anchorTag' style={{lineHeight: '40px'}}>
            <div className='title'>{card.title}</div>
            </Link>
            <div className='description'>{card.description}</div>
            <hr />
            <div className='time-difficulty'>
              <i className="fa-regular fa-clock"></i>
              <span className='time'>{card.time} minutes</span>
              <i className="fa-regular fa-heart"></i>
              <span className='difficulty'>{card.difficulty} health points</span>
            </div>
          </div>
        </div>
      ))}
    </div>
    </>
  )
}
